import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import type { TSpaceBase } from '@onesource/schemas';
import { useState } from 'react';

import { FeedTabContent } from './feed-tab-content';

interface CommunityTabContentProps {
  subSpaces: TSpaceBase[]; // FEED type sub-spaces
  parentSpace: TSpaceBase;
}

/**
 * Community Tab Content
 * Shows sub-tabs for each FEED sub-space within the Community section
 * Each sub-tab displays posts from that specific feed
 */
export const CommunityTabContent = ({ subSpaces, parentSpace }: CommunityTabContentProps) => {
  const [activeSubTab, setActiveSubTab] = useState(0);

  if (subSpaces.length === 0) {
    return <Alert severity="info">No community feeds available in this space.</Alert>;
  }

  const currentFeed = subSpaces[activeSubTab];

  return (
    <Box>
      {/* Sub-tabs for each FEED sub-space - only show if more than one */}
      {subSpaces.length > 1 && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs
            value={activeSubTab}
            onChange={(_, newValue) => setActiveSubTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {subSpaces.map(feed => (
              <Tab
                key={feed.id}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {feed.icon && <span>{feed.icon}</span>}
                    <span>{feed.name}</span>
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>
      )}

      {/* Feed content for the selected sub-tab */}
      {currentFeed && <FeedTabContent subSpace={currentFeed} parentSpace={parentSpace} />}
    </Box>
  );
};
